import { useState, useRef, useEffect, useCallback } from "react";

const useCountOnView = (targetNumber, duration = 1000, threshold = 0.3) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  // startCounting을 useCallback으로 감싸서 의존성 문제 해결
  const startCounting = useCallback(() => {
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentNumber = Math.floor(progress * targetNumber);

      setCount(currentNumber);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [duration, targetNumber]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          startCounting();
        }
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [startCounting, threshold]);

  return [count, ref];
};

export default useCountOnView;
